import _ from 'lodash';
import ow from 'ow';
import { notBlankValidator } from './owValidators';

export class VisibilityMapping {
  constructor(flagPropertyName) {
    ow(
      flagPropertyName,
      'flagPropertyName',
      ow.string.validate(notBlankValidator)
    );

    this.flagPropertyName = flagPropertyName;
  }
}

export class TextMapping {
  static ALLOWED_PROPERTIES = ['innerText', 'textContent'];

  constructor(sourcePropertyName, targetPropertyName) {
    ow(
      sourcePropertyName,
      'sourcePropertyName',
      ow.string.validate(notBlankValidator)
    );
    ow(
      targetPropertyName,
      'targetPropertyName',
      ow.string.validate(notBlankValidator)
    );
    if (!TextMapping.ALLOWED_PROPERTIES.includes(targetPropertyName)) {
      throw new Error(
        `Unrecognized targetPropertyName [${targetPropertyName}]`
      );
    }

    this.sourcePropertyName = sourcePropertyName;
    this.targetPropertyName = targetPropertyName;
  }
}

export class WrappedElement {
  constructor(
    doc,
    id,
    selector = null,
    textMapping = null,
    visibilityMapping = null,
    canBeDisabled = false
  ) {
    this.doc = doc;
    this.id = id;
    this.selector = selector;
    this.textMapping = textMapping;
    this.visibilityMapping = visibilityMapping;
    this.canBeDisabled = canBeDisabled;
  }

  get element() {
    const parent = this.doc.getElementById(this.id);
    return _.isNull(this.selector)
      ? parent
      : parent.querySelector(this.selector);
  }

  copyWith(field, value) {
    const result = new WrappedElement(
      this.doc,
      this.id,
      this.selector,
      this.textMapping,
      this.visibilityMapping,
      this.canBeDisabled
    );
    result[field] = value;
    return result;
  }

  withCanBeDisabled() {
    return this.copyWith('canBeDisabled', true);
  }

  withVisibilityMapping(value) {
    return this.copyWith('visibilityMapping', value);
  }

  withTextMapping(value) {
    return this.copyWith('textMapping', value);
  }

  toggleVisibility(view) {
    if (this.visibilityMapping) {
      const flag = this.visibilityMapping.flagPropertyName;
      this.element.style.display = view[flag] ? '' : 'none';
    }
  }

  updateText(view) {
    if (this.textMapping) {
      const source = this.textMapping.sourcePropertyName;
      const target = this.textMapping.targetPropertyName;
      this.element[target] = view[source];
    }
  }

  disable() {
    if (this.canBeDisabled) {
      this.element.disabled = 'disabled';
      this.element.readOnly = 'readOnly';
    }
  }

  addEventListener(action, callback) {
    this.element.addEventListener(action, callback);
  }

  setAttribute(key, value) {
    this.element.setAttribute(key, value);
  }
}
